export default __webpack_public_path__ + "static/media/right-mobile-header-bg.fec24085.svg";